<template>
  <div id="search-form">
    <form @submit.prevent class="container d-flex flex-column">
      <div class="row mb-3">
        <fieldset class="search col-md-3">
          <legend>{{ $t('form.search.legend') }}</legend>
          <ncs-select field="ncs_documents.subcorpus"/>
          <ncs-search-type/>
        </fieldset>
        <fieldset class="result col-md-9">
          <legend>{{ $t('form.result.legend') }}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-result-type/>
            </div>
            <div class="col-md-6">
              <ncs-order-selector/>
            </div>
            <div class="col-md-3">
              <ncs-page-size-selector/>
            </div>
            <div class="col-md-12" v-if="(resultType === 'interventions' || resultType === 'intervention') && elements === 'texts'">
              <intervention-filter
                  id="ncs_texts.interventions"
                  element-type="ncs_units"
                  element-filter-id="ncs_units.searchable_info"
                  :exclude-infos="['Énfasis', 'Sigla', 'Risa']"
              />
            </div>
            <div class="col-md-offset-3 col-md-6" v-if="resultType === 'matching_expressions'">
              <ncs-matching-expressions-group-selector/>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="row mb-3">
        <fieldset class="sensibility col-md-3">
          <legend>{{ $t('form.sensibility.legend') }}</legend>
          <ncs-global-option-checkbox name="ncs_accent" :value="true"/>
          <ncs-global-option-checkbox name="case" :value="true"/>
        </fieldset>
        <fieldset class="filters col-md-9">
          <legend>{{ $t('form.filters.legend') }}</legend>
          <div class="row">
            <div class="col-md-4">
              <ncs-select field="ncs_texts.grupo_edad"/>
            </div>
            <div class="col-md-4">
              <ncs-number-select-filter type="number" name="ncs_texts.edad_from" field="ncs_texts.edad"
                                        :min="15" :max="100" operator="gteq"/>
            </div>
            <div class="col-md-4">
              <ncs-number-select-filter type="number" name="ncs_texts.edad_to" field="ncs_texts.edad"
                                        :min="15" :max="100" operator="lteq" :reverse="true"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_texts.rol"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_texts.estudios"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_texts.sexo"/>
            </div>
            <div class="col-md-12">
              <ncs-multi-select field="ncs_texts.hablante" :searchable="true"
                                :dependencies="['ncs_texts.grupo_edad', 'ncs_texts.rol', 'ncs_texts.estudios', 'ncs_texts.sexo']"/>
            </div>
            <div v-show="elements === 'units'" class="col-md-12">
              <intervention-filter id="ncs_units.searchable_info"
                                   element-type="ncs_units"
                                   element-filter-id="ncs_units.searchable_info"/>
            </div>
            <div v-show="elements === 'tokens'" class="col-md-12">
              <intervention-filter id="ncs_tokens.searchable_info"
                                   element-type="ncs_tokens"
                                   element-filter-id="ncs_tokens.searchable_info"/>
            </div>
          </div>
        </fieldset>
      </div>
      <ncs-element-section/>
      <div class="btn-group align-self-end">
        <ncs-back-button/>
        <ncs-reset-button/>
        <ncs-search-button/>
      </div>
    </form>
    <ncs-result>
      <ncs-frequency-result/>
      <ncs-full-frequency-result/>
      <ncs-kwic-result/>
      <ncs-matching-expressions-result/>
      <ncs-context-result/>
      <interventions-result/>
      <intervention-result/>
    </ncs-result>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Ncs from 'ncs'
import InterventionsResult from './InterventionsResult.vue'
import InterventionResult from './InterventionResult.vue'
import InterventionFilter from "./InterventionFilter.vue";

export default {
  extends: Ncs.defaultComponents.NcsForm,
  components: { InterventionFilter, InterventionsResult, InterventionResult },
  computed: mapState({
    elements: s => s.elements.type,
    resultType: s => s.api.resultType
  }),
  watch: {
    resultType(value, oldValue) {
      // When entering or leaving the interventions result type, reset the searchable_info filter
      if (value === 'intervention' && oldValue !== 'interventions' ||
          value === 'interventions' && oldValue !== 'intervention' ||
          oldValue === 'intervention' && value !== 'interventions' ||
          oldValue === 'interventions' && value !== 'intervention') {
        this.$store.commit('filters/resetFilter', 'ncs_units.searchable_info')
        this.$store.commit('filters/resetFilter', 'ncs_tokens.searchable_info')
      }
    }
  }
}
</script>
<style lang="scss">
@import "../scss/variables";

legend {
  color: $primary;
  border-bottom: 1px solid $primary;
  font-size: 14px;
  margin-bottom: 5px;
}

label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
}

.form-group {
  margin-bottom: 0.25rem;
}
</style>
